export default "__VITE_ASSET__DJg$CT0t__"